import { css } from '@emotion/react';
import { colors, spacing } from '#themes/stena-recycling';

export const styles = {
  group: css`
    width: 100%;
    display: block;
  `,
  label: css`
    display: block;
  `,
  div: ({
    depth,
    expandable,
    showCheckbox,
  }: {
    depth: number;
    expandable: boolean;
    showCheckbox: boolean;
  }) => css`
    box-sizing: border-box;
    width: 100%;
    padding: ${spacing.xmsmall};
    padding-left: calc(${spacing.xmsmall} + ${depth} * ${spacing.xmsmall});
    display: grid;
    gap: ${spacing.xsmall};
    align-items: center;
    grid-template-columns: ${showCheckbox ? '1.5rem ' : ''} ${expandable ? '1fr 1.5rem' : '1fr'};
    user-select: none;
    font-weight: bold;
    border-bottom: ${depth === 0 ? `1px solid ${colors.monochrome.grey20}` : 'none'};

    outline: 0;
    background: transparent;
    text-align: left;
    display: grid;
    cursor: ${expandable ? 'pointer' : 'default'};
  `,
  labelTextButton: css`
    width: 100%;
    outline: 0;
    border: 0;
    padding: 0;
    background: transparent;
    font: inherit;
    color: inherit;
    text-align: left;
    cursor: pointer;
  `,
  ItemText: css`
    display: flex;
    flex-direction: column;
  `,
  labelIcon: css`
    outline: 0;
    border: 0;
    padding: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `,
};
